__turbopack_context__.v({
  "container": "rJ_g0W_container",
  "debugContainer": "rJ_g0W_debugContainer",
  "open": "rJ_g0W_open",
  "toggler": "rJ_g0W_toggler",
});
